'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _cancelSubscriptionForm = require('./cancel-subscription-form');

var _cancelSubscriptionForm2 = _interopRequireDefault(_cancelSubscriptionForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CancelSubscriptionPage = _react2['default'].createClass({

    displayName: "CancelSubscriptionPage",

    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'cancelSubscriptionForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'isHf': _react2['default'].PropTypes.bool, // maybe get dynamically from helpers
        'isTeamAdmin': _react2['default'].PropTypes.bool,
        'hasHipaa': _react2['default'].PropTypes.bool,
        'hasBothApiAndUiPlans': _react2['default'].PropTypes.bool,
        'redirectUrl': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {};
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'isIFrame': false
        };
    },
    componentDidMount: function componentDidMount() {
        if (this.props.isIFrame) {
            parent.hellofaxJS.resizeFancyBoxPopup({ width: 500, height: 450 });
            parent.$('#fancybox-frame').width(480);
        }
    },


    render: function render() {
        var siteCode = this.props.isHf ? _hfReactHelper2['default'].HfSites.SITE_CODE_HF : _hfReactHelper2['default'].HfSites.SITE_CODE_HS;

        var form = _jsx(_cancelSubscriptionForm2['default'], {
            tabOffset: this.props.tabOffset,
            isHf: this.props.isHf,
            isTeamAdmin: this.props.isTeamAdmin,
            hasHipaa: this.props.hasHipaa,
            hasBothApiAndUiPlans: this.props.hasBothApiAndUiPlans,
            redirectUrl: this.props.redirectUrl,
            method: 'POST',
            namespace: this.props.cancelSubscriptionForm.namespace,
            action: _hfReactHelper2['default'].urlHelper('account/cancelSubscription', siteCode),
            fields: this.props.cancelSubscriptionForm.fields,
            values: this.props.cancelSubscriptionForm.values,
            errors: { 'global': this.state.error }
        });

        return _jsx('div', {
            className: 'm-settings--cancel'
        }, void 0, form);
    }
});

module.exports = CancelSubscriptionPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/cancel-subscription/cancel-subscription-page.jsx
 ** module id = 770
 ** module chunks = 0
 **/